export default __webpack_public_path__ + "static/media/data-security.13a7e5b8.png";